export const getJpdViewsServicePathPrefix = () => {
	return '/gateway/api/jpd';
};

export const getViewsServicePrefix = () => '/gateway/api/jpd/views';
